import { type ITemMemberPermission, resolveTeamPermissions } from 'BreetHelpers';
import { selectUser, selectUserData, useAppSelector } from 'BreetRedux';
import { useCallback, useMemo } from 'react';

export const usePermissions = () => {
	const userData = useAppSelector(selectUserData);
	const { isLoading } = useAppSelector(selectUser);

	const grantedPermissions = useMemo(() => (userData ? resolveTeamPermissions(userData) : []), [userData]);

	const hasPermission = useCallback(
		(requiredPermission: ITemMemberPermission) => grantedPermissions.includes(requiredPermission),
		[grantedPermissions]
	);

	const hasAnyPermission = useCallback(
		(requiredPermissions: ITemMemberPermission[]) =>
			requiredPermissions.some((requiredPermission) => grantedPermissions.includes(requiredPermission)),
		[grantedPermissions]
	);

	const hasAllPermissions = useCallback(
		(requiredPermissions: ITemMemberPermission[]) =>
			requiredPermissions.every((requiredPermission) => grantedPermissions.includes(requiredPermission)),
		[grantedPermissions]
	);

	return {
		permissions: grantedPermissions,
		hasPermission,
		hasAnyPermission,
		hasAllPermissions,
		loading: isLoading,
	};
};
